import { gql } from "graphql-request";

export const GOODS_ISSUE_VIEW = gql`
  query GoodsIssuesViewAggrid($aggridInput: AnyAggridInput!) {
    GoodsIssuesViewAggrid(aggridInput: $aggridInput) {
      count
      results {
        id
        unique_id
        posted_date
        created_date
        reference_unique_id
        source_warehouse_name
        type
        created_by
        created_by_object {
          user_unique_id
          first_name
          last_name
          email
          img_url
        }
        remark
        aggrid_status
      }
    }
  }
`;
